import { render, staticRenderFns } from "./TopNavbarUser.vue?vue&type=template&id=297ee57b&"
import script from "./TopNavbarUser.vue?vue&type=script&lang=js&"
export * from "./TopNavbarUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports